






import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIWizardHeadingIndicatable } from "../../../../../../domain/format";
import { ContentMixin } from "./mixins";

@Component
export default class WizardContentHeadingIndicator extends Mixins(ContentMixin) {
  get text(): string {
    return instanceOfIWizardHeadingIndicatable(this.content)
      ? this.content.fixedText
      : "";
  }
}
